import {apiRequest} from "./ApiRequest";

const getOrders = params => {
    return apiRequest("get", "/orders", null, params).then(response => {
        return Promise.resolve(response.data.map(o => ({
            ...o,
            clientId: o.individualClientId || o.corporateClientId,
            clientType: o.individualClientId ? "individual" : "corporate"
        })));
    });
};

const createOrder = data => {
    return apiRequest("post", "/orders", data).then(response => {
        return Promise.resolve(response.data);
    });
};

const rebalance = data => {
    return apiRequest("post", "/rebalance", data).then(response => {
        return Promise.resolve(response.data);
    });
};

export {getOrders, createOrder, rebalance};